"use client";

import { createContext, useContext } from "react";

const FlowOverlayContainmentContext = createContext(false);

export const FlowOverlayContainmentProvider = FlowOverlayContainmentContext.Provider;

export const useFlowOverlayContainment = () => useContext(FlowOverlayContainmentContext);
